import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchWindows, createWindow, updateWindow, deleteWindow } from '../api/adminService';

export const useWindows = () => {
  const queryClient = useQueryClient();

  // Consulta para obtener las ventanas
  const { data, error, isLoading } = useQuery({
    queryKey: ['windows'],
    queryFn: fetchWindows,
  });

  // Mutación para crear una ventana
  const createMutation = useMutation({
    mutationFn: createWindow,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['windows'] });
    },
  });

  // Mutación para actualizar una ventana
  const updateMutation = useMutation({    
    mutationFn: ({ id, data }) => updateWindow(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['windows'] });
    },
  });

  // Mutación para eliminar una ventana
  const deleteMutation = useMutation({
    mutationFn: deleteWindow,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['windows'] });
    },
  });

  return {
    windows: data,
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};